import { Component, ElementRef, OnDestroy, OnInit, ViewChild } from "@angular/core";
import { OrderWizardService } from "../_service/order-wizard.service";
import { CommonModule } from "@angular/common";
import { TranslateModule } from "@ngx-translate/core";
import { CorpCheckboxComponent, CorpLoadingComponent } from "@corporate-tailwind/component";
import { ReactiveFormsModule } from "@angular/forms";

export class FormatText {
    title: string | null = null;
    subTitle: string | null = null;
    container: ContainerText[] | null = null;
}
export class ContainerText {
    // title: string | null = null;
    index: string | null = null;
    blockTextArray: BlockText[] | null = null;
}

export class BlockText {
    type:  'p' | 'bp' = 'p';
    // value: string | null = null;
}

@Component({
    selector: 'order-wizard-term-and-condition',
    imports: [CommonModule,ReactiveFormsModule, TranslateModule, CorpLoadingComponent, CorpCheckboxComponent],
    templateUrl: './order-wizard-term-and-condition.component.html',
    styleUrls: ['./order-wizard-term-and-condition.component.scss'],
    animations: [ ]
})
export class OrderWizardTermAndConditionComponent implements OnInit, OnDestroy {
@ViewChild('scrollContainer') scrollContainer!: ElementRef;
// numbers = Array.from({ length: 13 }, (_, i) => i + 1);
containerTextArray: ContainerText[] = [];

isScrollAtBottom = false;
hasScrolled = false;

    constructor(
        public _orderWizardService: OrderWizardService,
    ) {  }

    ngOnInit(): void {
        let containerTextArray: ContainerText[] = [];

        containerTextArray.push(this.addContainer('01', ['p']));
		containerTextArray.push(this.addContainer('02', ['p','p','p','p']));
        containerTextArray.push(this.addContainer('03', ['p','p']));
        containerTextArray.push(this.addContainer('04', ['p','p']));
        containerTextArray.push(this.addContainer('05', ['p']));
        containerTextArray.push(this.addContainer('06', ['p']));
        containerTextArray.push(this.addContainer('07', ['p','p']));
        containerTextArray.push(this.addContainer('08', ['p']));
        containerTextArray.push(this.addContainer('09', ['p','p','p','p']));
        containerTextArray.push(this.addContainer('10', ['p','p']));
        containerTextArray.push(this.addContainer('11', ['p','p','p']));
        containerTextArray.push(this.addContainer('12', ['p','p','bp','bp','p','p','p','p','p','p','p']));
        containerTextArray.push(this.addContainer('13', ['p','p','p','bp','bp','bp','bp','bp','bp','p','p']));

        this.containerTextArray = containerTextArray;
        // console.log('containerTextArray', containerTextArray);

    }

    addContainer(index: string, types: ('p' | 'bp')[]): ContainerText {
        return {
            index: index,
            blockTextArray: types.map(type => ({ type }))
        };
    }

    ngOnDestroy(): void {

    }

    onScroll(): void {
        const el = this.scrollContainer.nativeElement;
        if (el.scrollTop > 0) {
            this.hasScrolled = true;
        }
        const atBottom = el.scrollTop + el.clientHeight >= el.scrollHeight - 10;
        this.isScrollAtBottom = this.hasScrolled && atBottom;

        if(this.isScrollAtBottom){
            console.log('enable');
            this._orderWizardService.enableControl(x=>x.step05?.isGtcAccepted);
        }
            
    }

}